<div class="timeline">
    <div *ngFor="let event of events" class="timeline-row">
        <div class="timeline-item">
            <div class="timestamp">
                <span class="time">{{ event.timestampFormatted }}</span>
                <span class="user">{{ event.user?.name }}</span>
                <span class="action">{{ (event.title ?? '') | translate }}</span>
            </div>

            <ng-container *ngIf="getLabeler(event.topic) as labeler; else rawText">
                <div
                    class="change-card"
                    *ngIf="
                    event.oldReference !== undefined && event.reference !== undefined
                    "
                    >
                    <dependent-choice
                        [selectedId]="event.oldReference"
                        [topic]="event.topic"
                        [showLabel]="true"
                        [labelOnDemand]="labeler"
                        [reduced]="true"
                        ></dependent-choice>
                    <div class="arrow-wrapper">
                        <mat-icon class="arrow">arrow_forward</mat-icon>
                    </div>
                    <dependent-choice
                        [selectedId]="event.reference"
                        [topic]="event.topic"
                        [showLabel]="true"
                        [labelOnDemand]="labeler"
                        [reduced]="true"
                        ></dependent-choice>
                </div>
            </ng-container>

            <ng-template #rawText>
                <div class="change-card" *ngIf="event.oldReference || event.reference || (event.topic === 'comment' && event.commentContent)">
                    <ng-container *ngIf="event.topic === 'comment'; else defaultRefs">
                        <div class="comment-content" [innerHTML]="event.commentContent"></div>
                    </ng-container>
                    <ng-template #defaultRefs>
                        <span *ngIf="event.oldReferenceLabel">{{ event.oldReferenceLabel }}</span>
                        <span *ngIf="event.oldReferenceLabel && event.referenceLabel" class="arrow">→</span>
                        <span *ngIf="event.referenceLabel">{{ event.referenceLabel }}</span>
                    </ng-template>
                    <div *ngIf="event.topic === 'media' && event.mediaPreviewUrl" class="media-preview">
                        <img
                            [src]="event.mediaPreviewUrl"
                            alt="Media Preview"
                            class="timeline-media-image"
                            />
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>
